import React from "react";

import FooterModel from "../models/FooterModel";

import { inject, observer } from 'mobx-react';
import { shapes } from '@flint/framework';

import "./Footer.css";
import whiteWiley from "../../../assets/whitewiley.png"

const Footer = ({ FooterStore }) => {

    const [footerBooks, serFooterBooks] = React.useState([]);

    React.useEffect(() => {
        FooterStore.fetch();
        serFooterBooks(FooterStore.footerBooks);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="footer">
            <div className="wiley-logo">
                <img src={whiteWiley} alt="vet-logo" />
            </div>
            <div className="wiley-text-box">
                <p className="wiley-text">
                    The content powering this tool is based on the world-renowned
                    Blackwell’s Five-Minute Veterinary Consult Series. These books are
                    edited by certified veterinarians. The content summarizes the latest
                    research and is updated every quarter.
                </p>
                <div className="copyright-text">
                    <p>Copyright</p>
                    <p>{(new Date().getFullYear())}</p>
                </div>
            </div>
            <p className="writen-by-text">AUTHORS / EDITORS</p>
            <div className="footer-links">
                <div className="writer-names">
                    {footerBooks.map(book =>
                        <div className="writer" key={book.isbn}>
                            <p className="writer-about">{book.title}</p>
                            {book.author.split("~").map(author =>
                                <p className="writer-name" key={author}>{author.split(",")[1]} {author.split(",")[0]}</p>
                            )}
                        </div>
                    )}
                </div>
                <div className="more-links">
                    <ul>
                        <li>
                            <a
                                href="https://www.wiley.com/terms-of-use"
                                target="_blank"
                                rel="noreferrer"
                            >
                                Terms of Service
                            </a>
                        </li>
                        <li className="copyright-tab">Copyright {(new Date().getFullYear())}</li>
                        <li><a href="https://newsroom.wiley.com/newsroom-home/default.aspx" target="_blank" rel="noopener noreferrer">Newsletter</a></li>
                        <li><a href="https://www.wiley.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
                        <li><a href="https://www.wiley.com/aboutus" target="_blank" rel="noopener noreferrer">About</a></li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

Footer.propTypes = {
    FooterStore: shapes.modelOf(FooterModel),
};

export default inject("FooterStore")(observer(Footer));